import type {ActionCallback} from 'features/eag-grid';

/**
 * Configures the VEHICLE_HISTORY header control. Grid codes differ per entry point: the service
 * case header passes the `service-history-*` grids (their definitions carry the copy actions),
 * the vehicle header passes the view-only `vehicle-history-*` grids. Action callbacks are injected
 * because the copy dialogs live in the workshop module, which @dms/shared cannot import.
 */
export type VehicleHistoryControlConfig = {
  vehicleId: string;
  serviceRequestsGridCode: string;
  workItemsGridCode: string;
  serviceRequestsActionCallback?: ActionCallback;
  workItemsActionCallback?: ActionCallback;
};
